import * as i0 from '@angular/core';
import { Injectable, Inject, EventEmitter, Component, ViewChild, Input, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i3 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTabsModule } from '@angular/material/tabs';

class EIPGridSettingsService {
    constructor(http, environmentvalue) {
        this.http = http;
        this._webApiUrl = environmentvalue.baseUrl;
    }
    httpPostCallWithHeader(WebApiURL, parameters, _headers) {
        const body = parameters;
        return this.http.post(WebApiURL, body, { headers: _headers });
    }
    submitData(data, _authparams) {
        const _webApiUrl = this._webApiUrl + 'ccapi/GeneralRequest/InsertUserDefaultValues';
        return this.httpPostCallWithHeader(_webApiUrl, data, _authparams);
    }
    /*Get Grid Data From DB */
    getgridDatafromDB(data, _authparams) {
        const _webApiUrl = this._webApiUrl + 'ccapi/GeneralRequest/GetUserDefaultValues';
        return this.httpPostCallWithHeader(_webApiUrl, data, _authparams);
    }
}
EIPGridSettingsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsService, deps: [{ token: i1.HttpClient }, { token: 'environment' }], target: i0.ɵɵFactoryTarget.Injectable });
EIPGridSettingsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () {
        return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['environment']
                    }] }];
    } });

class GridSettingsHelper {
    //   getColumnValues(objMap: {}): any[] {
    //     var temparray=objMap
    //     return null;
    //   }
    getGridDataList(_gridDataList, _arrayList, data) {
        let _distinctItem = {};
        if (_arrayList && _arrayList.length > 0) {
            _arrayList.forEach(element => {
                _distinctItem = {};
                _distinctItem = _gridDataList['table'].find(function (_item) {
                    return _item.mudvD_Column_Name == element;
                    // if (_item.mudvD_Column_Name == element) {
                    //     return 0
                    // }
                    // else {
                    //     return -1
                    // }
                });
                if (!_distinctItem) {
                    _gridDataList['table'].push({
                        mudvD_Grid_ID: data.requestedparamsforgetdatafromDB['strGridID'],
                        mudvD_Column_Name: element,
                        mudvD_Sorting_Order: _gridDataList['table'].length + 1,
                        mudvD_Is_ColumnVisible: "Y",
                        mudvD_Is_ColumnFreezed: "N",
                    });
                }
            });
        }
        return _gridDataList;
    }
}

const sampleProducts = [
    {
        ProductID: 1,
        ProductName: 'Chai',
        SupplierID: 1,
        CategoryID: 1
    },
    {
        ProductID: 2,
        ProductName: 'Tea',
        SupplierID: 2,
        CategoryID: 2
    },
    {
        ProductID: 3,
        ProductName: 'Cofeee',
        SupplierID: 3,
        CategoryID: 3
    },
    {
        ProductID: 4,
        ProductName: 'Drink',
        SupplierID: 4,
        CategoryID: 4
    }
];

class EIPGridSettingsComponent {
    constructor(sharedservice, el, renderer) {
        this.sharedservice = sharedservice;
        this.el = el;
        this.renderer = renderer;
        this.columns = [{ field: 'ProductID' }, { field: 'ProductName' }, { field: 'QuantityPerUnit' }];
        this.gridSettingsHelper = new GridSettingsHelper();
        this.opendropdown = false;
        this.gridData = [];
        // public mockproductgriddata: any = productmock;
        this.settingdiv = false;
        this.columnname = [];
        this.status = false;
        this.isLocked = false;
        this.islockable = true;
        this.cdkdisabled = false;
        this.responsedata = [];
        this.resdata = [];
        this.savedata = [];
        this.objdata = [];
        this.GridDataList = [];
        this.temparray = [];
        this.resultdataarray = [];
        this.opened = false;
        this.lockstatus = [false];
        this.viewstatus = [true];
        this.lockshow = [false];
        this.resultkeys = [];
        this.gridTestData = sampleProducts;
        this.testFlag = 'N';
        this.ColumnVisibleProperty = false;
        this.searchGridParameters = {};
        this.searchGridParametersTest = {};
        this.gridDatafrm = {};
        this.reload = new EventEmitter();
        this.userDefaultValues = new EventEmitter();
        this.tab_Test = {};
        this.isDragRequired = true;
        this.isLockRequired = true;
        this.isViewRequired = true;
        this.columnarray = [];
        this.tempcolumnarr = [];
        this.submitFlag = 'N';
        this.documentClickSubscription = this.renderer.listen('document', 'click', (event) => {
            if (event.target.id == 'settingiconID') {
                this.settingdiv = !this.settingdiv;
                this.submitFlag = 'N';
            }
            else if (event.target.id == 'divCol' || event.target.id == 'divCol2' || event.target.id == 'spnCol' ||
                event.target.id == 'divCol1' || event.target.id == 'viewCol' || event.target.id == 'lockCol') {
                this.settingdiv = true;
            }
            else {
                this.settingdiv = false;
            }
        });
    }
    ngOnInit() {
        this.cdkdisabled = false;
        this.colfreeze = 'N';
        this.colvisible = 'Y';
        // this.getgriddatafromDB();
        this.savedata = [];
    }
    tabvaluechange(event) {
        // console.log(event, 'Tab value changes');
    }
    /*Get Grid Data from DB */
    getgriddatafromDB() {
        // this.cdkdisabled = false
        // this.colfreeze = "N"
        // this.colvisible = "Y"
        this.testFlag = this.searchGridParametersTest['testFlag'];
        if (this.gridDatafrm) {
            this.keys = this.gridDatafrm['columnName'];
            this.columnKeys = this.gridDatafrm['fieldName'];
        }
        if (this.gridData.length > 0 && this.gridData[0]) {
            this.keys = Object.keys(this.gridData[0]);
        }
        let data = this.searchGridParameters['requestedparamsforgetdatafromDB'];
        let _requestHeaders = this.searchGridParameters['headers'];
        this.subscribeddata = this.sharedservice.getgridDatafromDB(data, _requestHeaders).subscribe(result => {
            this.GridDataList = result;
            for (let i = 0; i < result.table.length; i++) {
                this.columnDataList = result.table[i].mudvD_Column_Name;
                this.temparray.push(this.columnDataList);
            }
            if (this.GridDataList['table']) {
                if (this.GridDataList['table'].length > 0) {
                    for (let i = 0; i < this.GridDataList['table'].length; i++) {
                        if (this.GridDataList['table'][i].mudvD_Is_ColumnFreezed == 'Y') {
                            this.lockstatus[i] = true;
                        }
                        else {
                            this.lockstatus[i] = false;
                        }
                        if (this.GridDataList['table'][i].mudvD_Is_ColumnVisible == 'N') {
                            this.viewstatus[i] = false;
                            this.lockshow[i] = true;
                        }
                        else {
                            this.viewstatus[i] = true;
                            this.lockshow[i] = false;
                        }
                    }
                }
            }
            if (this.GridDataList['table'].length == 0) {
                for (let i = 0; i < this.keys.length; i++) {
                    let index = this.keys.findIndex(a => a == this.keys[i]);
                    let data = {
                        mudvD_Grid_ID: this.searchGridParameters['requestedparamsforgetdatafromDB']['strGridID'],
                        mudvD_Column_Name: this.keys[i],
                        mudvD_Field_Name: this.columnKeys[i],
                        mudvD_Sorting_Order: index,
                        mudvD_Is_ColumnVisible: this.colvisible,
                        mudvD_Is_ColumnFreezed: this.colfreeze
                    };
                    this.GridDataList['table'].push(data);
                }
                if (this.GridDataList['table']) {
                    for (let x = 0; x < this.GridDataList['table'].length; x++) {
                        if (this.GridDataList['table'][x].mudvD_Is_ColumnVisible == 'Y') {
                            this.viewstatus[x] = true;
                            this.lockshow[x] = false;
                        }
                        else if (this.GridDataList['table'][x].mudvD_Is_ColumnVisible == 'N') {
                            this.viewstatus[x] = false;
                            this.lockshow[x] = true;
                        }
                        if (this.GridDataList['table'][x].mudvD_Is_ColumnFreezed == 'N') {
                            this.lockstatus[x] = false;
                        }
                        else if (this.GridDataList['table'][x].mudvD_Is_ColumnFreezed == 'Y') {
                            this.lockstatus[x] = true;
                        }
                    }
                }
            }
            const arr1 = this.keys;
            const arr2 = this.temparray;
            if (this.keys.length > this.temparray.length || this.keys.length == this.temparray.length) {
                this.keys = this.comparearrays(arr1, arr2);
                let data = this.searchGridParameters;
                this.GridDataList = this.gridSettingsHelper.getGridDataList(this.GridDataList, this.keys, data);
                if (this.GridDataList['table']) {
                    for (let x = 0; x < this.GridDataList['table'].length; x++) {
                        if (this.GridDataList['table'][x].mudvD_Is_ColumnVisible == 'Y') {
                            this.viewstatus[x] = true;
                            this.lockshow[x] = false;
                        }
                        else if (this.GridDataList['table'][x].mudvD_Is_ColumnVisible == 'N') {
                            this.viewstatus[x] = false;
                            this.lockshow[x] = true;
                        }
                        if (this.GridDataList['table'][x].mudvD_Is_ColumnFreezed == 'N') {
                            this.lockstatus[x] = false;
                        }
                        else if (this.GridDataList['table'][x].mudvD_Is_ColumnFreezed == 'Y') {
                            this.lockstatus[x] = true;
                        }
                    }
                }
                this.temparray = [];
            }
            this.userDefaultValuesEmittedValue = this.GridDataList;
            this.userDefaultValues.emit(this.userDefaultValuesEmittedValue);
            if (this.keys.length < this.temparray.length) {
                this.compare(arr1, arr2);
                let data = this.searchGridParameters;
            }
            if (this.subscribeddata) {
                this.subscribeddata.unsubscribe();
            }
        }, function (error) {
            console.log(error);
            if (this.subscribeddata) {
                this.subscribeddata.unsubscribe();
            }
        });
    }
    comparearrays(arr1, arr2) {
        let balance = 0;
        balance = arr1.length - arr2.length;
        arr2 = [...arr2, ...arr1.slice(arr2.length, arr2.length + balance)];
        let isItemAvailableInArr1 = false;
        if (arr1 && arr2) {
            arr2.forEach(arr2Element => {
                isItemAvailableInArr1 = false;
                arr1.filter(arr1Element => {
                    if (arr2Element == arr1Element) {
                        isItemAvailableInArr1 = true;
                    }
                });
                if (!isItemAvailableInArr1) {
                    arr1.push(arr2Element);
                }
            });
            return arr1;
        }
    }
    /*Union of Two Arrays */
    union_arrays(x, y) {
        this.temparray = [];
        let obj = {};
        for (let i = x.length - 1; i >= 0; --i) {
            obj[x[i]] = x[i];
        }
        for (let i = y.length - 1; i >= 0; --i) {
            obj[y[i]] = y[i];
        }
        let res = [];
        for (let k in obj) {
            if (obj.hasOwnProperty(k)) { // <-- optional
                this.resultdataarray.push(obj[k]);
            }
        }
    }
    /*Filtering two arrays */
    compare(arr1, arr2) {
        let array3 = arr1.filter(value => -1 !== arr2.indexOf(value));
        let different_result = this.arr_diff(array3, this.GridDataList['table']);
        this.GridDataList['table'] = [];
        for (let i = 0; i < different_result.length; i++) {
            let index = different_result.findIndex(a => a == different_result[i]);
            let data = {
                mudvD_Grid_ID: this.searchGridParameters['requestedparamsforgetdatafromDB']['strGridID'],
                mudvD_Column_Name: different_result[i],
                mudvD_Field_Name: different_result[i],
                mudvD_Sorting_Order: index,
                mudvD_Is_ColumnVisible: this.colvisible,
                mudvD_Is_ColumnFreezed: this.colfreeze // ,
            };
            this.GridDataList['table'].push(data);
            if (this.GridDataList['table'][i].mudvD_Is_ColumnVisible == 'Y') {
                this.viewstatus[i] = true;
                this.lockshow[i] = false;
            }
            else if (this.GridDataList['table'][i].mudvD_Is_ColumnVisible == 'N') {
                this.viewstatus[i] = false;
                this.lockshow[i] = true;
            }
            if (this.GridDataList['table'][i].mudvD_Is_ColumnFreezed == 'N') {
                this.lockstatus[i] = false;
            }
            else if (this.GridDataList['table'][i].mudvD_Is_ColumnFreezed == 'Y') {
                this.lockstatus[i] = true;
            }
        }
    }
    arr_diff(a1, a2) {
        let a = [], diff = [];
        for (let i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }
        for (let i = 0; i < a2.length; i++) {
            if (a[a2[i].mudvD_Column_Name]) {
                a[a2[i].mudvD_Column_Name] = true;
            }
            else {
                delete a[a2[i].mudvD_Column_Name];
            }
        }
        for (let k in a) {
            diff.push(k);
        }
        return diff;
    }
    /*Drag and Drop Event */
    drop(event) {
        moveItemInArray(this.GridDataList['table'], event.previousIndex, event.currentIndex);
        this.dragindex = event.currentIndex;
        // For achieving the changed elements inside tha array
        if (this.GridDataList['table'].length > 0) {
            for (let i = 0; i < this.GridDataList['table'].length; i++) {
                if (this.GridDataList['table'][i].mudvD_Is_ColumnFreezed == 'Y') {
                    this.lockstatus[i] = true;
                    this.cdkdisabled = true;
                }
                else {
                    this.lockstatus[i] = false;
                    this.cdkdisabled = false;
                }
                if (this.GridDataList['table'][i].mudvD_Is_ColumnVisible == 'N') {
                    this.viewstatus[i] = false;
                }
                else {
                    this.viewstatus[i] = true;
                }
            }
        }
    }
    /*toggle settings icon */
    toggle() {
        if (this.GridDataList['table'] && (JSON.stringify(this.searchGridParameters) != '{}' && this.submitFlag == 'Y')) {
            this.getgriddatafromDB();
        }
    }
    keydown(event) {
        if (event.keyCode === 27) {
            this.settingdiv = true;
        }
    }
    // @HostListener('document:click', ['$event'])
    // public documentClick(event: any): void {
    //   if (event.target.id == 'settingiconID') {
    //     this.settingdiv = !this.settingdiv;
    //     this.submitFlag = 'N';
    //   } else if (event.target.id == 'divCol' || event.target.id == 'divCol2' || event.target.id == 'spnCol' ||
    //     event.target.id == 'divCol1' || event.target.id == 'viewCol' || event.target.id == 'lockCol') {
    //     this.settingdiv = true;
    //          } else {
    //     this.settingdiv = false;
    //          }
    // }
    /*Save Columns  */
    onSubmitColumns() {
        this.savedata = [];
        this.resdata = [];
        this.objdata = [];
        if (this.GridDataList['table'].length > 0) {
            for (let x = 0; x < this.GridDataList['table'].length; x++) {
                let temp = this.searchGridParameters['requestedparamsforgetdatafromDB'];
                let data = {
                    intUID: this.searchGridParameters['requestedparamsforgetdatafromDB']['intUID'],
                    intCompanyCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['intCompanyCode'],
                    intDTCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['intDTCode'],
                    chrDOPTCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['chrDOPTCode'],
                    strGridID: this.searchGridParameters['requestedparamsforgetdatafromDB']['strGridID'],
                    objReqDetails: [
                        {
                            strGridID: this.GridDataList['table'][x].mudvD_Grid_ID,
                            strGridColumnName: this.GridDataList['table'][x].mudvD_Column_Name,
                            strFieldName: this.GridDataList['table'][x].mudvD_Field_Name,
                            intSortingOrder: this.GridDataList['table'][x].mudvD_Sorting_Order,
                            strIsColViewable: this.GridDataList['table'][x].mudvD_Is_ColumnVisible,
                            strIsColFreezed: this.GridDataList['table'][x].mudvD_Is_ColumnFreezed
                        }
                    ]
                };
                this.savedata.push(data);
            }
            for (let i = 0; i < this.savedata.length; i++) {
                this.resdata.push(this.savedata[i].objReqDetails);
            }
            for (let c = 0; c < this.resdata.length; c++) {
                this.objdata.push(Object.assign({}, ...this.resdata[c]));
            }
            this.testdata = {
                intUID: this.searchGridParameters['requestedparamsforgetdatafromDB']['intUID'],
                intCompanyCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['intCompanyCode'],
                intDTCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['intDTCode'],
                chrDOPTCode: this.searchGridParameters['requestedparamsforgetdatafromDB']['chrDOPTCode'],
                strGridID: this.searchGridParameters['requestedparamsforgetdatafromDB']['strGridID'],
                objReqDetails: this.objdata
            };
        }
        let _requestHeaders = this.searchGridParameters['headers'];
        this.sharedservice.submitData(this.testdata, _requestHeaders).subscribe(res => {
            this.responsedata = res;
            this.submitFlag = 'Y';
            console.log(this.responsedata, 'this.responsedata');
            console.log(this.testdata, 'this.testdata');
            this.reload.emit(this.testdata);
            this.testdata = [];
        }, (error) => {
            console.log(error);
        });
        this.settingdiv = true;
    }
    /*On Lock Click */
    onLockClick(i, key, event) {
        for (let x = 0; x < this.GridDataList['table'].length; x++) {
            if (this.GridDataList['table'][x].mudvD_Column_Name == key.mudvD_Column_Name) {
                if (this.GridDataList['table'][x].mudvD_Is_ColumnFreezed == 'N') {
                    this.GridDataList['table'][x].mudvD_Is_ColumnFreezed = 'Y';
                    this.lockstatus[i] = !this.lockstatus[i];
                }
                else {
                    this.GridDataList['table'][x].mudvD_Is_ColumnFreezed = 'N';
                    this.lockstatus[i] = !this.lockstatus[i];
                }
            }
        }
    }
    /*On View Click */
    onViewClick(i, key) {
        for (let x = 0; x < this.GridDataList['table'].length; x++) {
            if (this.GridDataList['table'][x].mudvD_Column_Name == key.mudvD_Column_Name) {
                if (this.GridDataList['table'][x].mudvD_Is_ColumnVisible == 'Y') {
                    this.GridDataList['table'][x].mudvD_Is_ColumnVisible = 'N';
                    this.viewstatus[i] = !this.viewstatus[i];
                    this.lockshow[i] = true;
                }
                else {
                    this.GridDataList['table'][x].mudvD_Is_ColumnVisible = 'Y';
                    this.viewstatus[i] = !this.viewstatus[i];
                    this.lockshow[i] = false;
                }
                break;
            }
        }
    }
    /* ngonchanges part */
    ngOnChanges() {
        this.getgriddatafromDB();
    }
    ngOnDestroy() {
        if (this.documentClickSubscription) {
            this.documentClickSubscription();
        }
    }
}
EIPGridSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsComponent, deps: [{ token: EIPGridSettingsService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
EIPGridSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EIPGridSettingsComponent, selector: "EIPGridSettings", inputs: { searchGridParameters: "searchGridParameters", searchGridParametersTest: "searchGridParametersTest", gridDatafrm: "gridDatafrm", tab_Test: "tab_Test", isDragRequired: "isDragRequired", isLockRequired: "isLockRequired", isViewRequired: "isViewRequired" }, outputs: { reload: "reload", userDefaultValues: "userDefaultValues" }, host: { listeners: { "keydown": "keydown($event)" } }, viewQueries: [{ propertyName: "menu", first: true, predicate: ["menu"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "\r\n<div class=\"container-fluid- grid-setting-div\">\r\n    <i class=\"fa fa-cog float-right\" aria-hidden=\"true\" id=\"settingiconID\"  title=\"Grid Settings\" (click)=\"toggle()\"></i>\r\n    <div id=\"divCol2\" cdkDropList  class=\"settingmenu-list\" *ngIf='settingdiv'\r\n      (cdkDropListDropped)=\"drop($event)\" >\r\n      <input type=\"submit\" class=\"btn  btn-primary m-2\" value=\"Submit\" id=\"settingbtnAdd\" (click)=\"onSubmitColumns()\">\r\n\r\n      <div id=\"divCol1\" class=\"head\">\r\n        Columns\r\n      </div>\r\n      <div *ngIf=\"isDragRequired\" class=\"grid-setting-head\">\r\n      <div id=\"divCol\" class=\"setting-usermenu\" cdkDragBoundary=\".grid-setting-head\" *ngFor=\"let key of GridDataList['table'];let i = index\" cdkDrag>\r\n\r\n            <span *ngIf=\"isLockRequired\" (click)=\"onLockClick(i,key,$event)\" [id]='i'><i id=\"lockCol\"  class=\"fa\"\r\n              [ngClass]=\"{'fa-lock':lockstatus[i],'fa-unlock':!lockstatus[i]}\" [hidden]=\"lockshow[i]\" title=\"Column Freeze\" aria-hidden=\"true\"></i></span>\r\n            <span *ngIf=\"isViewRequired\" (click)=\"onViewClick(i,key)\">\r\n              <i id=\"viewCol\" class=\"fa\" [ngClass]=\"{'fa-eye':viewstatus[i],'fa-eye-slash':!viewstatus[i]}\"\r\n              title=\"Column View\" aria-hidden=\"true\"></i></span>\r\n        <span id=\"spnCol\" title={{key.mudvD_Column_Name}}>{{key.mudvD_Column_Name}}</span>\r\n        <span cdkDragHandle><i title=\"Drag Here\" class=\"fa fa-ellipsis-v\"\r\n          aria-hidden=\"true\"></i></span>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"!isDragRequired\" class=\"grid-setting-head\">\r\n      <div id=\"divCol\" class=\"setting-usermenu\" cdkDragBoundary=\".grid-setting-head\"\r\n      *ngFor=\"let key of GridDataList['table'];let i = index\">\r\n\r\n          <span *ngIf=\"isLockRequired\" (click)=\"onLockClick(i,key,$event)\" [id]='i'>\r\n              <i\r\n              id=\"lockCol\"\r\n              class=\"fa\"\r\n              [ngClass]=\"{'fa-lock':lockstatus[i],'fa-unlock':!lockstatus[i]}\"\r\n              [hidden]=\"lockshow[i]\"\r\n              title=\"Column Freeze\"\r\n              aria-hidden=\"true\">\r\n            </i>\r\n          </span>\r\n          <span *ngIf=\"isViewRequired\" (click)=\"onViewClick(i,key)\">\r\n            <i\r\n            id=\"viewCol\"\r\n            class=\"fa\"\r\n            [ngClass]=\"{'fa-eye':viewstatus[i],'fa-eye-slash':!viewstatus[i]}\"\r\n            title=\"Column View\"\r\n            aria-hidden=\"true\">\r\n            </i>\r\n          </span>\r\n        <span id=\"spnCol\" title={{key.mudvD_Column_Name}}>{{key.mudvD_Column_Name}}</span>\r\n        <span *ngIf=\"isDragRequired\" cdkDragHandle><i title=\"Drag Here\" class=\"fa fa-ellipsis-v\"\r\n          aria-hidden=\"true\"></i></span>\r\n\r\n      </div>\r\n    </div>\r\n    </div>\r\n\r\n\r\n    <!-- <kendo-grid [data]=\"GridDataList['table']\"  [height]=\"370\" [resizable]=\"true\">\r\n        <kendo-grid-column *ngFor=\"let key of GridDataList['table'];let i = index\"  [reorderable]=\"!viewstatus[i]\"   [width]=\"250\" [hidden]=\"!viewstatus[i]\" [locked]=\"lockstatus[i]\"\r\n        [field]=\"key.mudvD_Field_Name\"\r\n        [title]=\"key.mudvD_Column_Name\"\r\n        >\r\n      </kendo-grid-column>\r\n\r\n\r\n  </kendo-grid> -->\r\n\r\n\r\n  <!-- <div >\r\n    <mat-tab-group (selectedTabChange)=\"tabChanged($event)\" >\r\n      <mat-tab  >\r\n        <ng-template\u00A0mat-tab-label>City\r\n          <a\u00A0class=\"address-edit\"><button\u00A0>\r\n            </button></a>\r\n        </ng-template>\r\n      </mat-tab>\r\n      <mat-tab  >\r\n        <ng-template\u00A0mat-tab-label>State\r\n          <a\u00A0class=\"address-edit\"><button\u00A0>\r\n            </button></a>\r\n        </ng-template>\r\n      </mat-tab>\r\n\r\n    </mat-tab-group>\r\n\r\n  </div> -->\r\n\r\n\r\n  <!-- Tab links -->\r\n\r\n\r\n\r\n  <!-- <----Test-->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPGridSettings', styles: [], template: "\r\n<div class=\"container-fluid- grid-setting-div\">\r\n    <i class=\"fa fa-cog float-right\" aria-hidden=\"true\" id=\"settingiconID\"  title=\"Grid Settings\" (click)=\"toggle()\"></i>\r\n    <div id=\"divCol2\" cdkDropList  class=\"settingmenu-list\" *ngIf='settingdiv'\r\n      (cdkDropListDropped)=\"drop($event)\" >\r\n      <input type=\"submit\" class=\"btn  btn-primary m-2\" value=\"Submit\" id=\"settingbtnAdd\" (click)=\"onSubmitColumns()\">\r\n\r\n      <div id=\"divCol1\" class=\"head\">\r\n        Columns\r\n      </div>\r\n      <div *ngIf=\"isDragRequired\" class=\"grid-setting-head\">\r\n      <div id=\"divCol\" class=\"setting-usermenu\" cdkDragBoundary=\".grid-setting-head\" *ngFor=\"let key of GridDataList['table'];let i = index\" cdkDrag>\r\n\r\n            <span *ngIf=\"isLockRequired\" (click)=\"onLockClick(i,key,$event)\" [id]='i'><i id=\"lockCol\"  class=\"fa\"\r\n              [ngClass]=\"{'fa-lock':lockstatus[i],'fa-unlock':!lockstatus[i]}\" [hidden]=\"lockshow[i]\" title=\"Column Freeze\" aria-hidden=\"true\"></i></span>\r\n            <span *ngIf=\"isViewRequired\" (click)=\"onViewClick(i,key)\">\r\n              <i id=\"viewCol\" class=\"fa\" [ngClass]=\"{'fa-eye':viewstatus[i],'fa-eye-slash':!viewstatus[i]}\"\r\n              title=\"Column View\" aria-hidden=\"true\"></i></span>\r\n        <span id=\"spnCol\" title={{key.mudvD_Column_Name}}>{{key.mudvD_Column_Name}}</span>\r\n        <span cdkDragHandle><i title=\"Drag Here\" class=\"fa fa-ellipsis-v\"\r\n          aria-hidden=\"true\"></i></span>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"!isDragRequired\" class=\"grid-setting-head\">\r\n      <div id=\"divCol\" class=\"setting-usermenu\" cdkDragBoundary=\".grid-setting-head\"\r\n      *ngFor=\"let key of GridDataList['table'];let i = index\">\r\n\r\n          <span *ngIf=\"isLockRequired\" (click)=\"onLockClick(i,key,$event)\" [id]='i'>\r\n              <i\r\n              id=\"lockCol\"\r\n              class=\"fa\"\r\n              [ngClass]=\"{'fa-lock':lockstatus[i],'fa-unlock':!lockstatus[i]}\"\r\n              [hidden]=\"lockshow[i]\"\r\n              title=\"Column Freeze\"\r\n              aria-hidden=\"true\">\r\n            </i>\r\n          </span>\r\n          <span *ngIf=\"isViewRequired\" (click)=\"onViewClick(i,key)\">\r\n            <i\r\n            id=\"viewCol\"\r\n            class=\"fa\"\r\n            [ngClass]=\"{'fa-eye':viewstatus[i],'fa-eye-slash':!viewstatus[i]}\"\r\n            title=\"Column View\"\r\n            aria-hidden=\"true\">\r\n            </i>\r\n          </span>\r\n        <span id=\"spnCol\" title={{key.mudvD_Column_Name}}>{{key.mudvD_Column_Name}}</span>\r\n        <span *ngIf=\"isDragRequired\" cdkDragHandle><i title=\"Drag Here\" class=\"fa fa-ellipsis-v\"\r\n          aria-hidden=\"true\"></i></span>\r\n\r\n      </div>\r\n    </div>\r\n    </div>\r\n\r\n\r\n    <!-- <kendo-grid [data]=\"GridDataList['table']\"  [height]=\"370\" [resizable]=\"true\">\r\n        <kendo-grid-column *ngFor=\"let key of GridDataList['table'];let i = index\"  [reorderable]=\"!viewstatus[i]\"   [width]=\"250\" [hidden]=\"!viewstatus[i]\" [locked]=\"lockstatus[i]\"\r\n        [field]=\"key.mudvD_Field_Name\"\r\n        [title]=\"key.mudvD_Column_Name\"\r\n        >\r\n      </kendo-grid-column>\r\n\r\n\r\n  </kendo-grid> -->\r\n\r\n\r\n  <!-- <div >\r\n    <mat-tab-group (selectedTabChange)=\"tabChanged($event)\" >\r\n      <mat-tab  >\r\n        <ng-template\u00A0mat-tab-label>City\r\n          <a\u00A0class=\"address-edit\"><button\u00A0>\r\n            </button></a>\r\n        </ng-template>\r\n      </mat-tab>\r\n      <mat-tab  >\r\n        <ng-template\u00A0mat-tab-label>State\r\n          <a\u00A0class=\"address-edit\"><button\u00A0>\r\n            </button></a>\r\n        </ng-template>\r\n      </mat-tab>\r\n\r\n    </mat-tab-group>\r\n\r\n  </div> -->\r\n\r\n\r\n  <!-- Tab links -->\r\n\r\n\r\n\r\n  <!-- <----Test-->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: EIPGridSettingsService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { menu: [{
                type: ViewChild,
                args: ['menu', { static: false }]
            }], searchGridParameters: [{
                type: Input
            }], searchGridParametersTest: [{
                type: Input
            }], gridDatafrm: [{
                type: Input
            }], reload: [{
                type: Output
            }], userDefaultValues: [{
                type: Output
            }], tab_Test: [{
                type: Input
            }], isDragRequired: [{
                type: Input
            }], isLockRequired: [{
                type: Input
            }], isViewRequired: [{
                type: Input
            }], keydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

// import { environment } from 'src/environments/environment';
class EIPGridSettingsModule {
}
EIPGridSettingsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPGridSettingsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsModule, declarations: [EIPGridSettingsComponent], imports: [FormsModule, GridModule, InputsModule,
        CommonModule, DropDownsModule, PopupModule, DialogsModule,
        HttpClientModule,
        // AngularFontAwesomeModule,
        FontAwesomeModule,
        DragDropModule,
        MatTabsModule], exports: [EIPGridSettingsComponent] });
EIPGridSettingsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsModule, imports: [[FormsModule, GridModule, InputsModule,
            CommonModule, DropDownsModule, PopupModule, DialogsModule,
            HttpClientModule,
            // AngularFontAwesomeModule,
            FontAwesomeModule,
            DragDropModule,
            MatTabsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGridSettingsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPGridSettingsComponent],
                    imports: [FormsModule, GridModule, InputsModule,
                        CommonModule, DropDownsModule, PopupModule, DialogsModule,
                        HttpClientModule,
                        // AngularFontAwesomeModule,
                        FontAwesomeModule,
                        DragDropModule,
                        MatTabsModule
                    ],
                    exports: [EIPGridSettingsComponent],
                }]
        }] });

/*
 * Public API Surface of eipgrid-settings
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPGridSettingsComponent, EIPGridSettingsModule, EIPGridSettingsService };
